import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=022a06c4&scoped=true&"
import script from "./DataManagement.vue?vue&type=script&lang=js&"
export * from "./DataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a06c4",
  null
  
)

export default component.exports